<template>
  <v-app class="grey lighten-5">
    <v-snackbar v-model="snackbar">
      {{ msg }}
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-container>
      <v-row class="justify-center">
        <div class="d-flex justify-center align-center flex-column" v-if="isLoading">
          <p>Carregando...</p>
          <v-progress-circular indeterminate color="primary" class="mb-0"></v-progress-circular>
        </div>
        <v-col class="col-12 col-md-10" v-if="!isLoading">
          <div class="d-flex flex-column flex-md-row align-center justify-space-between">
            <h2 class="text-center text-md-left primary--text ml-md-4">
              <v-icon class="primary--text mr-2">calendar_today</v-icon>Detalhe da Consulta
            </h2>
            <div class="text-center">
              <v-btn
                color="success"
                class="ml-3"
                :to="{name: 'ViewInterviewPsychologist', params: {id: profileToBeConsulted.id}}"
                v-if="loggedUser.is_chief_therapist && profileToBeConsulted.psychologist_questions"
              >
                Ver Formulário
              </v-btn>

              <div
                class="d-inline-block pa-3 rounded-lg gray white--text ml-3 mt-3 mt-md-0"
                v-if="loggedUser.is_chief_therapist && !profileToBeConsulted.psychologist_questions"
              >
                O paciente não preencheu o formulário
              </div>

              <v-btn
                class="ml-3 mt-3 mt-md-0 px-5"
                :href="`https://meet.jit.si/ondivan-consulta-${firstAppointment.id}`"
                target="_blank"
                color="primary"
                v-if="firstAppointment.status == 'SCHEDULED' && consultaDateTime <= nowDateTime"
              >
                <v-icon class="white--text mr-2">videocam</v-icon>
                Consulta
              </v-btn>
            </div>
          </div>
          <p
            v-if="firstAppointment.status == 'SCHEDULED' && consultaDateTime >= nowDateTime"
            class="col-12 ml-md-2 gray--text"
          >O botão para a consulta estará disponível na data e horário da consulta marcada.</p>
          <div class="row justify-center">
            <div class="col-12 col-md-5">
              <div
                class="box-item custom-radius bg-yellow d-flex flex-row align-center justify-space-between px-3 py-4"
              >
                <div class="d-flex flex-row align-center justify-center">
                  <v-icon class="primary--text mr-2">record_voice_over</v-icon>
                  <p class="ma-0 mr-2 gray--text">{{profileToBeConsulted.name}}</p>
                </div>
                <v-btn
                  class="bt-perfil"
                  @click="goProfileTerapeuta(profileToBeConsulted)"
                >Ver Perfil</v-btn>
              </div>
              <div
                class="box-item border-bottom d-flex flex-row align-center justify-space-between px-3 py-4"
              >
                <div class="d-flex flex-row align-center justify-center">
                  <v-icon class="primary--text mr-2">calendar_today</v-icon>
                  <p class="ma-0 mr-2 gray--text">{{ firstAppointment.date | formatDate }}</p>
                </div>
                <div class="d-flex flex-row align-center justify-center">
                  <v-icon class="primary--text mr-2">access_time</v-icon>
                  <p
                    class="ma-0 mr-2 gray--text"
                  >{{ firstAppointment.time | formatDateTZ(firstAppointment.date, firstAppointment.time) }}</p>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-5">
              <p class="ma-0 mr-2 gray--text text-center text-md-left">
                <strong>{{$t('pageConsulta.titleContato')}}</strong>
              </p>
              <div
                class="box-item bg-gray custom-radius d-flex flex-row align-center justify-space-start px-3 py-4"
              >
                <p class="ma-0 gray--text">
                  <strong>Email</strong>
                </p>
                <v-icon class="gray--text ml-2" size="30">email</v-icon>
                <p class="ma-0 ml-2 gray--text text-center">
                  <strong>{{profileToBeConsulted.email}}</strong>
                </p>
              </div>
            </div>
          </div>
          <div class="row justify-center align-center">
            <div
              class="col-12 col-md-3 text-center"
              v-if="firstAppointment.status === 'SCHEDULED' && firstAppointment.date > date && !loggedUser.is_chief_therapist"
            >
              <v-btn
                color="gray"
                @click="openModalInfo = true"
                class="white--text"
                height="50"
                min-width="100%"
              >
                Reagendar
              </v-btn>
              <ModalReagendarConsulta
                :is-dialog-open="openModalInfo"
                :codPsi="firstAppointment.psychologist"
                :codAppointment="firstAppointment.id"
                @close="openModalInfo = false"
              />
            </div>
            <!-- FINALIZAR -->
            <div
              class="col-12 col-md-3 text-center"
              v-if="firstAppointment.status == 'SCHEDULED' && !profileToBeConsulted.is_chief_therapist"
            >
              <v-btn
                :loading="isLoading"
                :disabled="isLoading"
                color="primary"
                height="50"
                min-width="100%"
                @click="doneConsultation(firstAppointment)"
              >Finalizar</v-btn>
            </div>
            <!-- FINALIZAR -->
            <div
              class="col-12 col-md-5 text-center"
              v-if="firstAppointment.status == 'CLOSED'"
            >
              <div class="grey white--text d-flex align-center justify-center pa-3">
                <span v-if="profileToBeConsulted.is_chief_therapist">
                  Consulta Finalizada. Em breve você receberá uma mensagem do terapeuta chefe falando sobre o resultado da análise do seu perfil!
                </span>
                <span v-else>
                  Consulta Finalizada.
                </span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import {
  getProfile,
} from '../../services/psychologists';

import generalService from '../../services/general';
import Api from '../../services/httpClient';
import ModalReagendarConsulta from '@/components/ModalReagendarConsulta';

export default {
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      time: new Date().toTimeString().substr(0, 8),
      nowDateTime: new Date().toISOString().substr(0, 19),
      cod: '',
      firstAppointment: {},
      profileToBeConsulted: {},
      openModalInfo: false,
      loggedUser: {},
      isLoading: false,
      dialog: false,
      rating: 0,
      comments: '',
      justification: '',
      isInvalid: false,
      isDisabled: true,
      snackbar: false,
      consultaDateTime: '',
      msg: '',
      category: '',
    };
  },
  components: {
    ModalReagendarConsulta
  },
  async created() {
    await this.getCod();
    // await this.verifyTherapistAppointments();
    await this.getCodParams();
    this.openModalInfo = false;
  },
  watch: {
    rating(val) {
      if (val > 0) {
        this.isInvalid = false;
      }
    },
    justification(val) {
      if (val) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
  },
  methods: {
    getCod() {
      this.cod = localStorage.getItem('user-id');
      this.category = localStorage.getItem('user-category');
    },
    goProfileTerapeuta(profileToBeConsulted) {
      if (!profileToBeConsulted.is_chief_therapist) {
        // Criar tela de psicólogo normal
        this.$router.push({
          name: 'ProfilePsicologoView',
          params: { id: profileToBeConsulted.slug },
        });
      } else {
        this.$router.push({
          name: 'ProfileTerapeuta',
          params: { id: profileToBeConsulted.id },
        });
      }
    },
    async getCodParams() {
      const { id } = this.$route.params;
      await this.getConsulta(id);
    },
    async getConsulta(id) {
      const { data } = await generalService.getAppointmentDetail(id);
      this.firstAppointment = data;
      this.consultaDateTime = this.firstAppointment.date.concat(
        'T',
        this.firstAppointment.time,
      );
      this.loggedUser = await getProfile(this.cod);
      console.log('loggedUser ', this.loggedUser);
      if (!this.loggedUser.is_chief_therapist) {
        this.profileToBeConsulted = await getProfile(this.firstAppointment.psychologist);
      } else {
        this.profileToBeConsulted = await getProfile(this.firstAppointment.patient_psychologist);
      }

      console.log("consulta: ", this.firstAppointment);
      this.isLoading = false;

      console.log('isso ', this.profileToBeConsulted);
    },
    doneConsultation(consulta) {
      this.isLoading=true;
      Api.post(
        `/psychologists/${this.cod}/appointments/${consulta.id}/closing`,
        {},
        {
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        },
      )
        .then(response => {
          const { data, status } = response;
          if (status === 200) {
            this.firstAppointment = data;
          }
        })
        .catch(error => {
          console.log(error);
        }).finally(()=>{
          this.isLoading=false;
        })
        ;
      console.log('terminou a consulta');
    },
    rescheduleConsultation(consulta) {
      Api.post(
        `/psychologists/${this.cod}/appointments/${consulta.id}/cancellation/`,
        {
          comments: this.justification,
        },
        {
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        },
      )
        .then(response => {
          const { data, status } = response;
          if (status === 200) {
            this.details = data;
            this.$router.replace({
              name: 'AgendamentoTerapeuta',
              params: { id: this.firstAppointment.psychologist },
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="css" scoped>
.toolbar {
  height: auto;
}

.v-toolbar__content {
  height: auto !important;
}

.my__toolbar {
  height: auto;
}

.box-item {
  width: 100%;
}

.custom-radius {
  border-radius: 5px;
}

.bg-yellow {
  background-color: #fffde3;
}

.bg-gray {
  background-color: #e0e0e0 !important;
}

.border-bottom {
  border-bottom: 1px solid #ccc;
}

.bt-perfil {
  font-size: 0.5rem;
}

.obs-text {
  font-size: 0.8rem;
}

.valor-consulta {
  font-size: 1.3rem;
}

.whats-img,
.whats-img .v-image__image--cover {
  width: 25px;
  height: 25px;
}

.skype-img,
.skype-img .v-image__image--cover {
  width: 25px;
  height: 25px;
}

.email-img,
.email-img .v-image__image--cover {
  width: 30px;
  height: 30px;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@media screen and (max-width: 420px) {
  .my__toolbar img {
    width: 50%;
  }
}
</style>
